export const collectionDetails = {
    onChangeCollectionDetails: (store, payload) => {
        store.setState({ collectionDetails: payload });
    },
};